import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { FundraiserService } from '../../../../services/fundraiser.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatButtonModule } from '@angular/material/button';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { NgClass, NgTemplateOutlet, NgIf, NgFor, UpperCasePipe, TitleCasePipe } from '@angular/common';

type LOCALE =
	| 'nl'
	| 'en'
	| 'es'
	| 'de'
	| 'fr'
	| 'bg'
	| 'hr'
	| 'cs'
	| 'da'
	| 'fi'
	| 'el'
	| 'hu'
	| 'it'
	| 'pl'
	| 'pt'
	| 'ro'
	| 'sk'
	| 'sv'
	| 'uk';
type NEW_CONTENT = {
	[key in LOCALE as string]?: string;
};
@Component({
    selector: 'app-translate-about',
    templateUrl: './translate-about.component.html',
    standalone: true,
    imports: [NgClass, ExtendedModule, MatButtonModule, MatDialogModule, FlexModule, MatFormFieldModule, FormsModule, MatInputModule, NgTemplateOutlet, NgIf, MatIconModule, MatProgressSpinnerModule, ReactiveFormsModule, MatMenuModule, NgFor, UpperCasePipe, TitleCasePipe]
})
export class TranslateAboutComponent implements OnInit {
	allLocales: LOCALE[] = [
		'nl',
		'en',
		'es',
		'de',
		'fr',
		'bg',
		'hr',
		'cs',
		'da',
		'fi',
		'el',
		'hu',
		'it',
		'pl',
		'pt',
		'ro',
		'sk',
		'sv',
		'uk',
	];
	allLanguages = {
		bg: 'Bulgarian',
		hr: 'Croatian',
		cs: 'Czech',
		da: 'Danish',
		fi: 'Finnish',
		el: 'Greek',
		hu: 'Hungarian',
		it: 'Italian',
		pl: 'Polish',
		pt: 'Portuguese',
		ro: 'Romanian',
		sk: 'Slovak',
		sv: 'Swedish',
		uk: 'Ukrainian',
		nl: 'Dutch',
		de: 'Deutsch',
		es: 'Spanish',
		en: 'English',
		fr: 'French',
	};
	originalLocale: LOCALE = 'nl';
	selectedLocale: LOCALE = 'en';
	languageIconPath: string =
		'https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/';
	translationLocaleArr: LOCALE[] = [];
	titleTranslation!: any;
	quillContent!: any;
	originalTitle!: any;
	titleFormGroup!: UntypedFormGroup;
	quillContentCtrl: UntypedFormControl = new UntypedFormControl();

	originalQuillContent!: any;
	originalDescription!: any;
	isLoading: boolean = false;
	isDisable: boolean = true;
	isAutoTranslating: boolean = false;
	newContent: NEW_CONTENT[] = [
		{ nl: '' },
		{ en: '' },
		{ es: '' },
		{ de: '' },
		{ fr: '' },
		{ fi: '' },
		{ hr: '' },
		{ hu: '' },
		{ it: '' },
		{ pl: '' },
		{ pt: '' },
		{ ro: '' },
		{ sk: '' },
		{ sv: '' },
		{ uk: '' },
		{ bg: '' },
		{ cs: '' },
		{ da: '' },
		{ el: '' },
	];
	maxLengthCheck: any;
	translatedTitle = $localize`:@@translate_about_translated_title: Translated Title`;

	constructor(
		private _formBuilder: UntypedFormBuilder,
		private notificationService: NotificationService,
		public fundraiserService: FundraiserService,

		@Inject(MAT_DIALOG_DATA) public data: { currentFundraiser: any },
		public dialogRef: MatDialogRef<TranslateAboutComponent>
	) {}

	ngOnInit(): void {
		this.originalLocale = this.data?.currentFundraiser?.language_code;

		this.originalTitle =
			this.data?.currentFundraiser?.translations?.[
				`title_${this.originalLocale}`
			] || this.data?.currentFundraiser?.title;

		this.titleFormGroup = this._formBuilder.group({
			translationTitle: [
				'',
				[
					Validators.minLength(5),
					Validators.maxLength(75),
					Validators.pattern(
						/^[\p{L}\p{N}\p{P}\p{S}\s\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FAC0}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}\u{2B05}\u{1F004}]*$/u
					),
				],
			],
			en: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			nl: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			es: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			de: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			fr: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			fi: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			hr: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			hu: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			it: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			pl: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			pt: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			ro: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			sk: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			sv: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			uk: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			bg: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			cs: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			da: ['', [Validators.minLength(5), Validators.maxLength(75)]],
			el: ['', [Validators.minLength(5), Validators.maxLength(75)]],
		});

		this.originalQuillContent =
			this.data?.currentFundraiser?.translations?.[
				`content_${this.originalLocale}`
			] || this.data?.currentFundraiser?.content;

		this.originalDescription =
			this.data?.currentFundraiser?.translations?.[
				`description_${this.originalLocale}`
			] || this.data?.currentFundraiser?.description;

		this.translationLocaleArr = this.getTranslatableLocale(this.originalLocale);

		this.initTranslations();

		// store edited titles
		this.titleFormGroup.valueChanges.subscribe((val) => {
			let editedTitle = this.titleFormGroup.get('translationTitle')?.value;
			this.titleFormGroup
				.get(this.selectedLocale)
				?.setValue(editedTitle, { emitEvent: false });

			this.changeAboutContent(val);
		});
		this.titleFormGroup.markAllAsTouched();
	}
	initTranslations() {
		let titleTranslation =
			this.data?.currentFundraiser?.translations?.[
				'title_' + this.translationLocaleArr[0]
			] || this.data?.currentFundraiser?.title;

		this.titleFormGroup
			.get('translationTitle')
			?.setValue(titleTranslation, { emitEvent: false });

		this.quillContent =
			this.data?.currentFundraiser?.translations?.[
				'content_' + this.translationLocaleArr[0]
			] || this.data?.currentFundraiser?.content;

		this.selectedLocale = this.translationLocaleArr[0];
	}
	changeLanguage(language: string) {
		switch (true) {
			case language.includes('nl'):
				this.selectedLocale = 'nl';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('es'):
				this.selectedLocale = 'es';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('de'):
				this.selectedLocale = 'de';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('fr'):
				this.selectedLocale = 'fr';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('bg'):
				this.selectedLocale = 'bg';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('hr'):
				this.selectedLocale = 'hr';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('cs'):
				this.selectedLocale = 'cs';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('da'):
				this.selectedLocale = 'da';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('fi'):
				this.selectedLocale = 'fi';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('el'):
				this.selectedLocale = 'el';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('hu'):
				this.selectedLocale = 'hu';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('it'):
				this.selectedLocale = 'it';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('pl'):
				this.selectedLocale = 'pl';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('pt'):
				this.selectedLocale = 'pt';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('ro'):
				this.selectedLocale = 'ro';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('sk'):
				this.selectedLocale = 'sk';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('sv'):
				this.selectedLocale = 'sv';
				this.changeTranslation(this.selectedLocale);
				break;
			case language.includes('uk'):
				this.selectedLocale = 'uk';
				this.changeTranslation(this.selectedLocale);
				break;
			default:
				this.selectedLocale = 'en';
				this.changeTranslation(this.selectedLocale);
		}
	}
	changeTranslation(selectedLocale: LOCALE) {
		let titleTranslation =
			this.titleFormGroup.get(selectedLocale)?.value ||
			this.data?.currentFundraiser?.translations?.['title_' + selectedLocale] ||
			this.data?.currentFundraiser?.title;

		this.titleFormGroup
			.get('translationTitle')
			?.setValue(titleTranslation, { emitEvent: false });

		// if edited content already exist for a locale then prefer that
		let editedContent = this.newContent.find(
			(content) => content[selectedLocale]
		)?.[selectedLocale];

		this.quillContent =
			editedContent ||
			this.data?.currentFundraiser?.translations?.[
				'content_' + selectedLocale
			] ||
			this.data?.currentFundraiser?.content;
	}
	/** when content is edited of any locale, it is updated to newContent */
	changeAboutContent(event: any) {
		this.newContent.map((content) => {
			if (content[this.selectedLocale] !== undefined) {
				content[this.selectedLocale] = event;
			}
			return content;
		});
		this.isDisable = false;
	}
	/** Remove all saved content */
	discardAllAboutChanges() {
		this.titleFormGroup.reset('');
		let titleTranslation =
			this.titleFormGroup.get(this.selectedLocale)?.value ||
			this.data?.currentFundraiser?.translations?.[
				'title_' + this.selectedLocale
			] ||
			this.data?.currentFundraiser?.title;
		this.titleFormGroup
			.get('translationTitle')
			?.setValue(titleTranslation, { emitEvent: false });

		this.quillContentCtrl.setValue(this.quillContent);

		this.newContent = this.newContent.map((content) => {
			return Object.assign({ [Object.keys(content)[0]]: '' });
		});

		this.isDisable = true;
		// this.changeDetectorRef.detectChanges();
	}
	getOriginalLocale() {
		return this.originalLocale;
	}
	getTranslatableLocale(originalLocale: LOCALE): LOCALE[] {
		return this.allLocales.filter((locale) => locale !== originalLocale);
	}
	getLanguage(locale: LOCALE) {
		return this.allLanguages[locale];
	}
	autoTranslate() {
		if (this.selectedLocale) {
			let body = {
				content: this.originalTitle,
				target_language: this.selectedLocale,
				source_language: this.originalLocale,
			};
			this.isAutoTranslating = true;
			this.fundraiserService.autoTranslateNew(body).subscribe(
				(response: any) => {
					this.titleFormGroup
						.get('translationTitle')
						?.setValue(response?.data?.translated_text);

					this.titleFormGroup
						.get('translationTitle')
						?.setValue(response?.data?.translated_text, {
							emitEvent: false,
						});
					this.titleFormGroup
						.get(this.selectedLocale)
						?.setValue(response?.data?.translated_text, {
							emitEvent: false,
						});

					// this.quillContentCtrl.setValue(
					// 	response?.data?.translated_text?.about
					// );
					// this.changeAboutContent(response?.data?.translated_text?.about);

					this.titleFormGroup.get('translationTitle')?.markAsDirty();
					this.titleFormGroup.get(this.selectedLocale)?.markAsDirty();

					this.isAutoTranslating = false;
				},
				(error: any) => {
					this.notificationService.openNotification(
						$localize`:@@translate_about_autoTranslating_notification:There was an error Auto Translating Fundraiser About`,
						'',
						'error'
					);
					this.isAutoTranslating = false;
				}
			);
		}
	}
	saveTranslations() {
		this.isLoading = true;
		let editedContent = this.newContent.filter((content: NEW_CONTENT) => {
			return !!content[Object.keys(content)[0]];
		});
		let observableSourceList: any = [];

		editedContent.map((content) => {
			let contentBody: any = {
				title:
					this.titleFormGroup.get(Object.keys(content)?.[0])?.value ||
					this?.data?.currentFundraiser?.title,
				slug: this.data?.currentFundraiser?.slug,
				language_code: Object.keys(content)?.[0],
				currency_code: this.data?.currentFundraiser?.currency_code,
				is_auto: false,
			};
			observableSourceList.push(
				this.fundraiserService.updateFundraiserTitleTranslation(contentBody)
			);
		});
		//length of results/response will be same as length of editedContent array, i.e if editedContent.length is 2 then results[0] and results[1]
		forkJoin(observableSourceList).subscribe(
			(results) => {
				this.isLoading = false;
				this.dialogRef.close(true);
			},
			(error) => {
				this.notificationService.openNotification(
					$localize`:@@translate_about_errorTranslating:There was an error Translating Fundraiser About`,
					'close',
					'error'
				);
				this.isLoading = false;
			}
		);
	}
	onCloseClick() {
		this.dialogRef.close();
	}
	checkBoolean(event: boolean) {
		this.maxLengthCheck = event;
	}
}
